import { useQuery } from '@tanstack/react-query';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { DataRoomVisitStat } from 'router/subrouters/DataRoom/models/Dashboard';

const VISIT_STATS_QUERY_KEY = 'data-room-visit-stats';

type UseVisitStatsQueryProps = {
  dataRoomId?: string;
};

export default function useVisitStatsQuery({
  dataRoomId,
}: UseVisitStatsQueryProps) {
  const query = useQuery<DataRoomVisitStat[]>({
    queryKey: [VISIT_STATS_QUERY_KEY, { dataRoomId }],
    queryFn: async () => {
      const { data } = await dataRoomApi.room.getVisitStats(dataRoomId);

      return data;
    },
    enabled: !!dataRoomId,
  });

  useInvalidateQueryOnUnmount(VISIT_STATS_QUERY_KEY);

  return query;
}
